import React, { useEffect, useState, useRef } from 'react';
import Button from '@material-ui/core/Button';
import '../../../scss/components/_import_templates.scss';
import API_PATH from "../../../constants/config.json";
import Cookies from 'js-cookie';
import { withStyles, makeStyles } from '@material-ui/core/styles';


const axios = require('axios');
const AWS = require('aws-sdk');

const API_URL = process.env.REACT_APP_BASE_URL;

const useStyles2 = makeStyles(theme => ({
    disabled: {
        opacity: "50%"
    }
}));


const ImportTemplates = () => {

    const [clearStatus, setClearStatus] = useState(true);
    const [downloadSelectedStatus, setDownloadSelectedStatus] = useState(true);
    const [selectAllStatus, setSelectAllStatus] = useState(false);
    const [volumeValue, setVolumeValue] = useState(false);
    const [classValue, setClassValue] = useState(false);
    const [speedValue, setSpeedValue] = useState(false);
    const [intersectionValue, setIntersectionValue] = useState(false);
    const [idintityPool, setIdintityPool] = React.useState('');
    const [aswLogins, setAswLogins] = React.useState('');
    const [loader, setLoader] = React.useState(false);
    const disableClass = useStyles2();

    useEffect(() => {
        getAswToken();
    }, [])

    useEffect(() => {
        if (volumeValue === true || classValue === true || speedValue === true || intersectionValue === true) {
            setClearStatus(false);
            setDownloadSelectedStatus(false)
        }
        else {
            setClearStatus(true);
            setDownloadSelectedStatus(true)
        }

        if (volumeValue === true && classValue === true && speedValue === true && intersectionValue === true) {
            setSelectAllStatus(true);
        }
        else {
            setSelectAllStatus(false);
        }
    }, [volumeValue, classValue, speedValue, intersectionValue]);

    const handleVolumeValue = () => {
        setVolumeValue(!volumeValue);
    }

    const handleClassValue = () => {
        setClassValue(!classValue);
    }

    const handleSpeedValue = () => {
        setSpeedValue(!speedValue);
    }

    const handleIntersectionValue = () => {
        setIntersectionValue(!intersectionValue);
    }

    const handleClearSelection = () => {
        setVolumeValue(false);
        setClassValue(false);
        setSpeedValue(false);
        setIntersectionValue(false);
    }

    const handleSelectAll = () => {
        setVolumeValue(true);
        setClassValue(true);
        setSpeedValue(true);
        setIntersectionValue(true);
    }

    const getAswToken = () => {
        try {
            axios({
                method: 'get',
                url: API_URL + API_PATH.getAWSs3TokenAPI,
                headers: {
                    'agencyid': sessionStorage.getItem('agency_id'),
                    'payload': Cookies.get('payload'),
                },
            }).then(async function (response) {
                if (response.status && response.status == '200') {
                    let aswData = response.data;
                    setIdintityPool(aswData.data.IdentityPoolId);
                    setAswLogins(aswData.data.Logins);
                } else {
                    console.log("");
                }
            })
        } catch (error) {
            console.error(error);
        }
    }

    const handleDownloadSelection = () => {
        setLoader(true);
        try {
            axios({
                method: 'post',
                headers: {
                    'agencyid': sessionStorage.getItem('agency_id'),
                    'payload': Cookies.get('payload')
                },
                url: API_URL + API_PATH.downloadTemplates,
                data: { templates: [volumeValue, classValue, speedValue, intersectionValue] }
            })
                .then(async function (response) {
                    if (response.status && response.status == 200) {
                        const url = response.data.url;
                        if (url.length) {
                            let link = document.createElement("a");
                            link.href = url;
                            link.target = '_blank';
                            link.click();
                        } else {
                            let OIDToken = Cookies.get('idToken');
                            AWS.config.update({
                                region: 'us-west-2',
                                credentials: new AWS.CognitoIdentityCredentials({
                                    IdentityPoolId: idintityPool,
                                    Logins: {
                                        [aswLogins]: OIDToken
                                    }
                                })
                            });
                            let s3 = new AWS.S3();
                            s3.getObject({ Bucket: url.bucket_name, Key: 'downloads/' + url.file_name }, function (
                                error,
                                data
                            ) {
                                if (error != null) {
                                    console.log('error', error);
                                } else {
                                    let blob = new Blob([data.Body], { type: data.ContentType });
                                    let link = document.createElement("a");
                                    link.href = window.URL.createObjectURL(blob);
                                    link.download = url.file_name;
                                    link.click();
                                }
                            });
                        }
                        setVolumeValue(false);
                        setClassValue(false);
                        setSpeedValue(false);
                        setIntersectionValue(false);
                        setLoader(false);
                    }
                })
                .catch(function (error) {
                    console.error(error);
                    setLoader(false);
                })
        } catch (error) {
            console.error(error);
            setLoader(false);
        }
    }

    return (
        <>
            <div className='import-templates-container'>
                <label className='import-tamplates-title'>
                    Download and fill in the corresponding studies templates.
                </label>
                <div className='import-templates-file-container'>
                    <div className='import-templates-file'>
                        <input type="checkbox" id="volume_template" name="volume_template" checked={volumeValue} onChange={handleVolumeValue} />
                        <label for="volume_template">DTP_ Volume Template_V1.0.0(2022-08-08).xls</label>
                    </div>
                    <div className='import-templates-file'>
                        <input type="checkbox" id="class_template" name="class_template" checked={classValue} onChange={handleClassValue} />
                        <label for="class_template">DTP_ Class Template_V1.0.0(2022-08-08).xls</label>
                    </div>
                    <div className='import-templates-file'>
                        <input type="checkbox" id="speed_template" name="speed_template" checked={speedValue} onChange={handleSpeedValue} />
                        <label for="speed_template">DTP_ Speed Template_V1.0.0(2022-08-08).xls</label>
                    </div>
                    <div className='import-templates-file'>
                        <input type="checkbox" id="intersection_template" name="intersection_template" checked={intersectionValue} onChange={handleIntersectionValue} />
                        <label for="intersection_template">DTP_ Intersection Template_V1.0.0(2022-08-08).xls</label>
                    </div>
                </div>
                <div className='import-templates-footer'>
                    <Button className='import-templates-button button-selected-all' disabled={selectAllStatus} classes={{disabled: disableClass.disabled}} onClick={handleSelectAll}>Select all</Button>
                    <Button className='import-templates-button button-clear' disabled={clearStatus} classes={{disabled: disableClass.disabled}} onClick={handleClearSelection}>Clear</Button>
                    <Button className='import-templates-button button-download' disabled={downloadSelectedStatus} classes={{disabled: disableClass.disabled}} onClick={handleDownloadSelection}>Download selected {!loader ? <img src={require('../../../assets/icons/download_alternative.svg')} /> : <div className={'loader'}></div>}</Button>
                </div>
            </div>
        </>
    );
}

export default ImportTemplates;